import { Stack, Typography, Box } from "@mui/material";
import LegendItem from "./LegendItem";
import { greenColor, yellowColor, redColor } from "./constants";

export default function Legend() {
  return (
    <Box sx={{ mt: 4, width: "100%", maxWidth: 1300 }}>
      <Typography variant="h6" sx={{ mb: 2 }}>
        Legend
      </Typography>

      <Stack spacing={3}>
        <Stack spacing={0.25}>
          <Stack direction="row" spacing={0.5} sx={{ alignItems: "center" }}>
            <Box sx={{ width: 12, height: 12, borderRadius: 0.5, bgcolor: greenColor }} />
            <Typography variant="caption">Strong</Typography>
          </Stack>
          <Stack direction="row" spacing={0.5} sx={{ alignItems: "center" }}>
            <Box sx={{ width: 12, height: 12, borderRadius: 0.5, bgcolor: yellowColor }} />
            <Typography variant="caption">Moderate</Typography>
          </Stack>
          <Stack direction="row" spacing={0.5} sx={{ alignItems: "center" }}>
            <Box sx={{ width: 12, height: 12, borderRadius: 0.5, bgcolor: redColor }} />
            <Typography variant="caption">Needs improvement</Typography>
          </Stack>
        </Stack>

        <Box>
          <Stack spacing={0.5} sx={{ mb: 1.5 }}>
            <Typography variant="subtitle2" sx={{ color: "text.secondary" }}>
              Rebounding
            </Typography>
            <Typography variant="caption" sx={{ color: "text.secondary" }}>
              3P Crash% based on rough positional thresholds (G = Guard, W = Wing, B = Big)
            </Typography>
          </Stack>
          <Stack direction="row" spacing={4} sx={{ flexWrap: "wrap", gap: 2 }}>
            <LegendItem
              title="3P Crash%"
              description="% of 3PA opportunities where player crashed the glass (excludes shooter unless they crashed)"
            />
          </Stack>
        </Box>

        <Box>
          <Stack spacing={0.5} sx={{ mb: 1.5 }}>
            <Typography variant="subtitle2" sx={{ color: "text.secondary" }}>
              Passing
            </Typography>
          </Stack>
          <Stack direction="row" spacing={4} sx={{ flexWrap: "wrap", gap: 2 }}>
            <LegendItem
              title="Hit Ahead"
              description="Complete pass advancing the ball up court"
            />
            <LegendItem
              title="Paint Touch"
              description="Controlled paint touch (excludes offensive rebounds)"
            />
            <LegendItem
              title="Pot. AST"
              description="Pass where receiver shot within 1 dribble and 2.5 seconds"
            />
          </Stack>
        </Box>

        <Box>
          <Stack spacing={0.5} sx={{ mb: 1.5 }}>
            <Typography variant="subtitle2" sx={{ color: "text.secondary" }}>
              Shooting
            </Typography>
            <Typography variant="caption" sx={{ color: "text.secondary" }}>
              Broken down by contest level: Uncontested | Lightly | Heavily. Colors based on FG% (min 2 FGA)
            </Typography>
          </Stack>
        </Box>
      </Stack>
    </Box>
  );
}
